import type { jsPDF } from 'jspdf';

let normalFontCache: string | null = null;
let boldFontCache: string | null = null;

/**
 * CDN에서 한글 폰트를 로드하여 jsPDF에 등록
 * - 폰트 파일은 최초 1회만 다운로드 (normal, bold 각각)
 * - 각 PDF 인스턴스마다 폰트 등록
 */
export const loadKoreanFont = async (pdf: jsPDF) => {
  // Normal 폰트 로드
  if (!normalFontCache) {
    try {
      const normalFontUrl =
        'https://cdn.jsdelivr.net/npm/@expo-google-fonts/nanum-gothic@0.4.0/400Regular/NanumGothic_400Regular.ttf';

      const normalResponse = await fetch(normalFontUrl);
      if (!normalResponse.ok) {
        throw new Error('한글 Normal 폰트를 불러오는데 실패했습니다.');
      }

      const normalArrayBuffer = await normalResponse.arrayBuffer();
      normalFontCache = btoa(
        new Uint8Array(normalArrayBuffer).reduce((data, byte) => data + String.fromCodePoint(byte), '')
      );
    } catch (error) {
      throw new Error('한글 Normal 폰트를 불러오는데 실패했습니다.');
    }
  }

  // Bold 폰트 로드
  if (!boldFontCache) {
    try {
      const boldFontUrl =
        'https://cdn.jsdelivr.net/npm/@expo-google-fonts/nanum-gothic@0.4.0/700Bold/NanumGothic_700Bold.ttf';

      const boldResponse = await fetch(boldFontUrl);
      if (!boldResponse.ok) {
        throw new Error('한글 Bold 폰트를 불러오는데 실패했습니다.');
      }

      const boldArrayBuffer = await boldResponse.arrayBuffer();
      boldFontCache = btoa(
        new Uint8Array(boldArrayBuffer).reduce((data, byte) => data + String.fromCodePoint(byte), '')
      );
    } catch (error) {
      throw new Error('한글 Bold 폰트를 불러오는데 실패했습니다.');
    }
  }

  // 폰트 등록
  pdf.addFileToVFS('NanumGothic-Regular.ttf', normalFontCache);
  pdf.addFileToVFS('NanumGothic-Bold.ttf', boldFontCache);
  pdf.addFont('NanumGothic-Regular.ttf', 'NanumGothic', 'normal');
  pdf.addFont('NanumGothic-Bold.ttf', 'NanumGothic', 'bold');
};
